package com.essntl.features.task.data.supabase

import com.essntl.features.task.domain.model.TaskModel
import core.dateformat.utils.fromDDTOMM
import kotlinx.serialization.json.JsonElement
import kotlinx.serialization.json.JsonPrimitive

internal fun TaskModel.toRequestMap(): Map<String, JsonElement> {
    val requestMap = mutableMapOf<String, JsonElement>()

    if (!notes.isNullOrEmpty()) {
        requestMap["notes"] = JsonPrimitive(notes)
    }

    if (!dueDate.isNullOrEmpty()) {
        dueDate?.let {
            requestMap["due_date"] = JsonPrimitive(fromDDTOMM(it))
        }
    }

    if (!title.isNullOrEmpty()) {
        requestMap["title"] = JsonPrimitive(title)
    }

    owner?.let { requestMap["owner_id"] = JsonPrimitive(it.id) }

    itineraryService?.let { requestMap["itinerary_service_id"] = JsonPrimitive(it.id) }

    itinerary?.let { requestMap["itinerary_id"] = JsonPrimitive(it.id) }

    proposal?.let { requestMap["proposal_id"] = JsonPrimitive(it.id) }

    if (status != null) {
        requestMap["status"] = JsonPrimitive(status!!.toDto())
    }

    return requestMap
}